import React, { useRef, useState } from 'react'
import Modal from '../../../../common/components/modal/Modal'
import { Text } from '../../../../common/components/text/Text'
import {Attributes} from '../../../../common/components/attribute/Attribute'
import { Input, Radio, Select } from '../../../../common/components/control/Control'
import { Button } from '../../../../common/components/button/Button'
import { Flex } from '../../../../common/components/flex/Flex'
import Icons from '../../../../common/components/icon/Icon'
import { Space } from '../../../../common/components/space/Space'
import classNames from 'classnames'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import swal from 'sweetalert'
import { connect } from 'react-redux';
import { dockCompanySetSelectedAction } from '../../../../store/action/dockActions';
import codeService from '../../../../services/codeService'
import { dockService } from '../../../../services/dockService'

interface ViewProps{
    dock: any[]
}

const DockView = (props: any) => { 
    const { onClose } = props
    const { handleSubmit } = useForm();
    // const { cmpid } = props
    const { docks } = props
    const [display, setDocks] = React.useState<any>([])
    const [form, setForm] = useState<ViewProps>({
        dock: []
    })
    const _getdockDetail = (() => {
        return dockService.getDockViewDetail(docks.companyid).subscribe({
            next: r => {
                setForm({ ...form, dock: r.data })
                r.data.map((data: any, i: any) => {
                    return form.dock.push(data)
                })
            },
            error: err => {
                console.error(err)
            }
        })
    })


    React.useEffect(() => {
        _getdockDetail()
    }, [])

    onsubmit = (e) => {
        // console.log(form)
        e.preventDefault()
        const { onClose } = props
        onClose()
    }
    // console.log(form.dock, 'form.dock')
    return (
        <Modal
            onClose={() => onClose()}
            className="dock-new-mode"
            title={'Dock Detail'}>
            <ModalBody>
                    {form.dock.length === 0 && (
                <>
                    <Space divheight={20} />
                    <Text variant='subtitle'center color="main" bold>No Dock Associated with this Company</Text>
                    <Space divheight={20} />
                </>
                )}
                {form.dock.map((dock: any, i: any) => [
                    <Attributes id={i} className ='dock-view'>
                        <div>
                            <Text variant='subtitle' color="main" bold>{dock.name}</Text>
                            <Text color="main" variant='subtitle' bold> {dock.port.city.name} ({dock.port.city.country.name}) </Text>
                        </div>
                    </Attributes>
                ])}
                <Space divheight={5} />
                <Flex jc='jc-center'>
                    <Button
                        block
                        type="button"
                        onClick={() => onClose()}
                        variant='transparent'>
                        <Flex>
                            <Icons icon="arrow_back" />
                                BACK
                            </Flex>
                    </Button>
                </Flex>
            </ModalBody>
        </Modal>
    )
}

export interface ModalbodyProps {
    children?: React.ReactNode
}

const ModalBody = ({ children, ...props }: ModalbodyProps) => {

    const modal = classNames('modalbody-container')

    return (
        <div className={modal}>
            {children}
        </div>
    )

}

const mapStateToProps = (state: any) => ({
    docks: state.dock.selectedCompany,

})
export default connect(
    mapStateToProps,
    {
        dockCompanySetSelectedAction
    }
)(DockView)
